module.exports = __webpack_public_path__ + "img/oem_help_long.b35c6536.png";